// Role permission philosophy:
// - workspace_reader: read everywhere, plus self-service MCP client lifecycle
//   (create/delete) so readers can provision a client and reach the
//   reader-available MCP tools. Tool-level gating restricts what that client
//   can then do. No other mutations.
// - workspace_admin: every permission.
// - platform_admin / platform_access_manager: workspace and member management.
//   There is no dedicated invite resource; workspace_member:invite covers
//   creating, deleting, and updating invites.

import type { RoleKey } from '.';
import type { Permission } from './permissions';
import { PERMISSIONS, Permissions } from './permissions';

const ALL_PERMISSIONS: readonly Permission[] = PERMISSIONS;

const READER_PERMS: readonly Permission[] = [
  ...ALL_PERMISSIONS.filter((p) => p.endsWith(':read')),
  Permissions.mcp_client.create,
  Permissions.mcp_client.delete,
];

const PLATFORM_ADMIN_PERMS: readonly Permission[] = [
  Permissions.workspace.read,
  Permissions.workspace.update,
  Permissions.workspace_member.invite,
  Permissions.workspace_member.delete,
  Permissions.workspace_member.read,
  Permissions.workspace_member.update,
  Permissions.user.read,
  Permissions.user.invite,
  Permissions.user.create,
];
const PLATFORM_ACCESS_MANAGER_PERMS: readonly Permission[] = [
  Permissions.workspace_member.invite,
  Permissions.workspace_member.delete,
  Permissions.workspace_member.read,
  Permissions.workspace_member.update,
  Permissions.workspace.update,
  Permissions.workspace.read,
];

export const ROLE_PERMISSIONS: Readonly<
  Record<RoleKey, ReadonlySet<Permission>>
> = {
  workspace_reader: new Set(READER_PERMS),
  workspace_admin: new Set(ALL_PERMISSIONS),
  platform_admin: new Set(PLATFORM_ADMIN_PERMS),
  platform_access_manager: new Set(PLATFORM_ACCESS_MANAGER_PERMS),
};
